module.exports = __webpack_public_path__ + "img/visa.5de7803c.svg";